
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 7.057l2.828-2.828.943.943L8.943 8l2.828 2.828-.943.943L8 8.943 5.172 11.77l-.943-.943L7.057 8 4.23 5.172l.943-.943L8 7.057z","fill-rule":"nonzero"}})])
          )
        }
      }
    